import { toast } from "react-toastify";

// Parse JWT payload safely
export const parseJwt = (token) => {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

// Get logged in user safely with token decoding fallback
export const getLoggedInUser = () => {
  const userStr = localStorage.getItem("user");
  const token = localStorage.getItem("token");
  let user = null;

  if (userStr) {
    try {
      user = JSON.parse(userStr);
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }

  // If token has payload with role/id/email, enrich user data
  if (token) {
    const jwtData = parseJwt(token);
    if (jwtData) {
      user = {
        ...(user || {}),
        role: user?.role || jwtData.role,
        id: user?.id || jwtData.id || jwtData.user_id,
        email: user?.email || jwtData.email,
        name: user?.name || jwtData.name,
      };
    }
  }

  return user;
};

// Logout function
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("admin_profile_persist");

  toast.success("Logged out successfully!");

  setTimeout(() => {
    window.location.href = "/sign-in";
  }, 300);
};

